import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import ColorPicker from 'lib/ui/ColorPicker'
import Slider from 'lib/ui/Slider'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'

export default function Border(props: {
  control: UseFormMethods['control']
  button: NavButtonWithSize
  inputNamePrefix: string
}) {
  const {control, button, inputNamePrefix} = props

  return (
    <CollapsibleSection
      label="Border"
      storageKey="blogPostButton.config.styling.typography"
    >
      <Controller
        name={`${inputNamePrefix}borderColor`}
        control={control}
        defaultValue={button.borderColor || '#000000'}
        render={({value, onChange}) => (
          <ColorPicker label="Color" color={value} onPick={onChange} />
        )}
      />
      <Controller
        name={`${inputNamePrefix}hoverBorderColor`}
        control={control}
        defaultValue={button.hoverBorderColor || '#000000'}
        render={({value, onChange}) => (
          <ColorPicker label="Hover Color" color={value} onPick={onChange} />
        )}
      />
      <Controller
        name={`${inputNamePrefix}borderWidth`}
        defaultValue={button.borderWidth || 0}
        control={control}
        render={({value, onChange}) => (
          <Slider
            min={0}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Width"
          />
        )}
      />
      <Controller
        name={`${inputNamePrefix}borderRadius`}
        defaultValue={button.borderRadius || 0}
        control={control}
        render={({value, onChange}) => (
          <Slider
            min={0}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Radius"
          />
        )}
      />
    </CollapsibleSection>
  )
}
